'use client'

import { PageClient } from '../page-client'
import { FeedTabs } from './feed-tabs'
import type { SocialDiscoveryFeedQuery } from '@web/gen/feed'
import type { InfiniteData } from '@tanstack/react-query'

export function MasterfeedTabsContent({
  initialDiscoveryInitialData,
}: {
  initialTab: string
  initialDiscoveryInitialData?: InfiniteData<SocialDiscoveryFeedQuery>
}) {
  return (
    <>
      <FeedTabs />
      <PageClient initialDiscoveryInitialData={initialDiscoveryInitialData} />
    </>
  )
}
